module.exports = __webpack_public_path__ + "img/9788983926074.1e756f4d.jpg";